/** @jsx jsx */
import { jsx } from '@emotion/react';
import {
  BoldTextV1,
  BoldTextV2,
  BoldTextV3,
  OfferIconArrowV1,
  OfferIconArrowV2,
  OfferIconArrowV3,
  OfferIconV1,
  OfferIconV2,
  OfferIconV3,
} from './StyledComponents';
import { getContent } from '@/lib';

type CurrencySymbolProp = {
  currencySymbol?: string | null;
};

const OfferSVG = (): JSX.Element => {
  return (
    <svg height="20" width="100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H42V18H4C1.79086 18 0 16.2091 0 14V4Z"
        fill="#FFD140"
      />
      <path
        d="M9.628 14.196C12.652 14.196 14.668 12.026 14.668 9.002C14.668 5.964 12.596 3.794 9.614 3.794C6.646 3.794 4.588 5.978 4.588 9.002C4.588 12.026 6.632 14.196 9.628 14.196ZM9.614 12.67C7.626 12.67 6.422 11.088 6.422 8.988C6.422 6.874 7.612 5.32 9.6 5.32C11.616 5.32 12.82 6.846 12.82 8.988C12.82 11.102 11.602 12.67 9.614 12.67ZM16.904 14H17.968C18.178 14 18.29 13.888 18.29 13.678V7.924H19.186C19.396 7.924 19.508 7.812 19.508 7.602V6.972C19.508 6.762 19.396 6.65 19.186 6.65H18.29V6.076C18.29 5.516 18.626 5.264 18.99 5.264C19.13 5.264 19.186 5.278 19.298 5.278C19.466 5.278 19.536 5.194 19.536 4.97V4.214C19.536 4.088 19.494 3.99 19.424 3.934C19.326 3.864 19.158 3.864 18.962 3.864C17.506 3.864 16.582 4.788 16.582 6.146V6.65H15.938C15.728 6.65 15.616 6.762 15.616 6.972V7.602C15.616 7.812 15.728 7.924 15.938 7.924H16.582V13.678C16.582 13.888 16.694 14 16.904 14ZM21.3883 14H22.4523C22.6623 14 22.7743 13.888 22.7743 13.678V7.924H23.6703C23.8803 7.924 23.9923 7.812 23.9923 7.602V6.972C23.9923 6.762 23.8803 6.65 23.6703 6.65H22.7743V6.076C22.7743 5.516 23.1103 5.264 23.4743 5.264C23.6143 5.264 23.6703 5.278 23.7823 5.278C23.9503 5.278 24.0203 5.194 24.0203 4.97V4.214C24.0203 4.088 23.9783 3.99 23.9083 3.934C23.8103 3.864 23.6423 3.864 23.4463 3.864C21.9903 3.864 21.0663 4.788 21.0663 6.146V6.65H20.4223C20.2123 6.65 20.1003 6.762 20.1003 6.972V7.602C20.1003 7.812 20.2123 7.924 20.4223 7.924H21.0663V13.678C21.0663 13.888 21.1783 14 21.3883 14ZM28.4367 14.224C30.0747 14.224 31.1807 13.384 31.6847 12.376C31.7827 12.18 31.7827 12.138 31.7827 12.096C31.7827 11.984 31.6567 11.9 31.4747 11.9H30.4107C30.2427 11.9 30.1307 11.97 30.0187 12.11C29.6967 12.544 29.1927 12.81 28.4787 12.81C27.2887 12.81 26.4767 11.942 26.3647 10.738L31.6707 10.752C31.8667 10.752 32.0067 10.64 32.0067 10.43V10.29C32.0067 8.148 30.7607 6.398 28.4087 6.398C26.1687 6.398 24.6567 8.064 24.6567 10.304C24.6567 12.6 26.1407 14.224 28.4367 14.224ZM26.4207 9.52C26.5607 8.358 27.3307 7.728 28.3947 7.728C29.4867 7.728 30.1867 8.512 30.2987 9.52H26.4207ZM33.7532 14H34.8172C35.0272 14 35.1392 13.888 35.1392 13.678V10.528C35.1392 9.016 35.4472 8.064 36.5392 8.064C36.7632 8.064 36.8752 8.106 36.9872 8.106C37.1552 8.106 37.2252 7.98 37.2252 7.812V6.804C37.2252 6.552 37.0572 6.468 36.7912 6.468C35.9512 6.468 35.2652 6.888 35.0132 7.63C35.0272 7.476 35.0272 7.308 35.0272 7.14V6.972C35.0272 6.762 34.9152 6.65 34.7052 6.65H33.7392C33.5292 6.65 33.4312 6.762 33.4312 6.972V13.678C33.4312 13.888 33.5432 14 33.7532 14Z"
        fill="#001435"
      />
      <path
        d="M49.0442 0H42V18H49.0442C49.86 18 50.3325 17.0758 49.8549 16.4145L44.9229 9.58549C44.6704 9.23598 44.6704 8.76402 44.9229 8.41451L49.8549 1.58549C50.3325 0.924163 49.86 0 49.0442 0Z"
        fill="#FFD140"
      />
    </svg>
  );
};

const OfferCSSV1 = (): JSX.Element => (
  <OfferIconV1>
    <BoldTextV1 data-testid="offer-header">
      {getContent('checkoutIncentives.offerHeader')}
    </BoldTextV1>
    <OfferIconArrowV1 />
  </OfferIconV1>
);

const OfferCSSV2 = (): JSX.Element => (
  <OfferIconV2>
    <BoldTextV2 data-testid="offer-header">
      {getContent('checkoutIncentives.offerHeader')}
    </BoldTextV2>
    <OfferIconArrowV2 />
  </OfferIconV2>
);

const OfferCSSV3 = ({ currencySymbol }: CurrencySymbolProp): JSX.Element => (
  <OfferIconV3>
    <BoldTextV3 data-testid="offer-header">
      {getContent('checkoutIncentives.getOfferButtonText', {
        currencySymbol,
      })}
    </BoldTextV3>
    <OfferIconArrowV3 />
  </OfferIconV3>
);

const DealsIcon = (): JSX.Element => (
  <svg
    width="31"
    height="29"
    viewBox="0 0 31 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.64842 1.14491C9.01799 0.781121 9.51499 0.624549 9.99425 0.675349C10.1535 0.670396 10.3162 0.688385 10.4781 0.731754L20.4135 3.39395C21.2674 3.62276 21.9955 4.18142 22.4375 4.94703L30.3419 18.6379C30.8022 19.435 30.5291 20.4543 29.7319 20.9146L16.2887 28.676C15.4916 29.1362 14.4722 28.8631 14.012 28.0659L13.5893 27.3337H2.33463C1.41416 27.3337 0.667969 26.5875 0.667969 25.6671L0.667969 10.3965C0.667969 9.50337 1.02642 8.64756 1.66295 8.02099L8.64842 1.14491ZM6.1076 14.3751C5.66557 13.6095 5.54578 12.6997 5.7746 11.8457L7.36286 5.9183L3.41671 9.80265C3.25758 9.9593 3.16797 10.1732 3.16797 10.3965V24.8337L12.1459 24.8337L6.1076 14.3751ZM13.5243 11.9008C14.858 12.2582 16.2288 11.4667 16.5862 10.133C16.9435 8.79937 16.1521 7.42853 14.8184 7.07117C13.4847 6.71382 12.1139 7.50527 11.7565 8.83894C11.3992 10.1726 12.1906 11.5434 13.5243 11.9008Z"
      fill="#38AF88"
    />
  </svg>
);

const OfferEndIcon = (): JSX.Element => (
  <svg
    width="9"
    height="18"
    viewBox="0 0 9 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.04424 0H0V18H7.04424C7.86001 18 8.33255 17.0758 7.85492 16.4145L2.92285 9.58549C2.67043 9.23598 2.67043 8.76402 2.92285 8.41451L7.85492 1.58549C8.33255 0.924163 7.86001 0 7.04424 0Z"
      fill="#FFD140"
    />
  </svg>
);

export {
  OfferSVG,
  DealsIcon,
  OfferCSSV1,
  OfferCSSV2,
  OfferCSSV3,
  OfferEndIcon,
};
